export const CHARGE_ANALYSIS_STATISTICS = "CHARGE_ANALYSIS_STATISTICS";
export const CHARGE_ANALYSIS_STATISTICS_PENDING = "CHARGE_ANALYSIS_STATISTICS_PENDING";
export const CHARGE_ANALYSIS_STATISTICS_FULFILLED = "CHARGE_ANALYSIS_STATISTICS_FULFILLED";
export const CHARGE_ANALYSIS_STATISTICS_REJECTED = "CHARGE_ANALYSIS_STATISTICS_REJECTED";

export const CHARGE_ANALYSIS_DOWNLOAD_REPORT = "CHARGE_ANALYSIS_DOWNLOAD_REPORT";
export const CHARGE_ANALYSIS_DOWNLOAD_REPORT_PENDING = "CHARGE_ANALYSIS_DOWNLOAD_REPORT_PENDING";
export const CHARGE_ANALYSIS_DOWNLOAD_REPORT_FULFILLED = "CHARGE_ANALYSIS_DOWNLOAD_REPORT_FULFILLED";
export const CHARGE_ANALYSIS_DOWNLOAD_REPORT_REJECTED = "CHARGE_ANALYSIS_DOWNLOAD_REPORT_REJECTED";

export const CHARGE_ANALYSIS_SET_RELATIVE_FILTER = 'CHARGE_ANALYSIS_SET_RELATIVE_FILTER';
export const CHARGE_ANALYSIS_SET_CLAIM_ID = 'CHARGE_ANALYSIS_SET_CLAIM_ID';

export const ChargeAnalysisStats = (pagination, sort, filter) => {
    return {
        type: CHARGE_ANALYSIS_STATISTICS,
        payload: { pagination, sort, filter },
    }
};

export const setRelativeFilter = (relativeFilterValue) => ({
    type: CHARGE_ANALYSIS_SET_RELATIVE_FILTER,
    payload: { relativeFilterValue }
});

export const download = (payload, showSignificantVariance,callback) => ({
    type: CHARGE_ANALYSIS_DOWNLOAD_REPORT,
    payload: { payload, callback,showSignificantVariance }
});

export const setClaimId = (claimId) => ({
    type: CHARGE_ANALYSIS_SET_CLAIM_ID,
    payload: { claimId }
});